var render = function render(){var _vm=this,_c=_vm._self._c;return _c('company-autocomplete',{attrs:{"types":['CORPORATOR'],"label":`${_vm.$t('choose.company_long')}*`,"phone-search":""},model:{value:(_vm.selectedCompany),callback:function ($$v) {_vm.selectedCompany=$$v},expression:"selectedCompany"}})
}
var staticRenderFns = []

export { render, staticRenderFns }